import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { memberFormConfigData, memberFormConfigDataSuccess, memberFormConfigDataFailure } from '../actions/memberFormConfig.actions';
import { environment } from 'src/environments/environment';
import { selectMemberFormConfigData } from '../selectors/memberFormConfig.selectors';
import { select, Store } from '@ngrx/store';

@Injectable()
export class MemberFormConfigDataEffects {
  memberFormConfigData$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.memberFormConfigData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(memberFormConfigData),
        withLatestFrom(this.store.pipe(select(selectMemberFormConfigData))),
        switchMap(([action, currentData]) => {
          console.log({currentData})
          if (currentData != undefined && Object.keys(currentData).length > 0) {
            console.log('Data already in store, no need to call API');
            console.log('return old fetch', new Date().toISOString())
            return;
          }
          const api = this.getApiEndpoint();
          const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
          const headers = {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
          };
          return this.http.get<any>(apiUrl, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('new fetch', new Date().toISOString())
              return memberFormConfigDataSuccess({ memberFormConfigData: data.data });
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [memberFormConfigDataFailure({ error: errorMessage })]; // Dispatch failure on error
            })
          );
        })
      )
    );
  }

  private getApiEndpoint(): string {
    return `/api/ap/customer/formConfig`
    // https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/corporateSignup/formConfig
  }
}
